import {message} from 'antd';
import {
  ADD_COMPANY_DATA,
  UPDATE_FAMILY_MEMBERS,
  AUTH_USER,
  CLEAR_AUTH_DATA,
  CLEAR_COMPANY_DATA,
  GET_COMPANY_DATA,
  UPDATE_CAR_COUNT,
  HIDE_COMPANY_LOAD,
  LOGIN_USER_FAILURE,
  LOGIN_USER_SUCCESS,
  SHOW_AUTH_LOAD,
  SHOW_COMPANY_LOAD,
  UPDATE_COMPANY_WAIVER_SIGNED,
  UPDATE_COMPANY_MEMBER_TNC,
  UPDATE_LOGOUT_MESSAGE,
  UPDATE_COMPANY_MEMBER_MRF,
  UPDATE_FAMILY_MEMBER_QUESTIONS,
  SET_FAMILY_MEMBER_REGISTRATION_FORM,
} from '../actionTypes';

const INITIAL_STATE = {
  authDetails: null,
  user: null,
  error: '',
  companyData: null,
  authLoading: {status: false, err: ''},
  companyDataLoadingStatus: true,
  logoutMessage: null,
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AUTH_USER:
      // console.log("reducer data is here: ", action.authDetails);
      return {
        ...state,
        authDetails: action.authDetails,
        authLoading: action.payload,
        companyDataLoadingStatus: true,
      };

    case LOGIN_USER_SUCCESS:
      return {
        ...state,
        user: action.userDetails,
        authLoading: action.payload,
      };

    case LOGIN_USER_FAILURE:
      return {
        ...state,
        error: 'email or password is incorrect',
        authLoading: action.payload,
      };
    case GET_COMPANY_DATA:
      return {
        ...state,
        companyData: action.payload,
        companyDataLoadingStatus: false,
      };
    case UPDATE_CAR_COUNT:
    return {
      ...state,
      companyData: {
        ...state.companyData,
        member: {
          ...state.companyData.member,
          car: action.payload,
        },
      },
    };
    case SHOW_AUTH_LOAD:
      return {
        ...state,
        authLoading: action.payload,
      };
    case UPDATE_LOGOUT_MESSAGE:
      return {
        ...state,
        logoutMessage: action.payload,
      };
    case CLEAR_AUTH_DATA:
      return {
        authDetails: null,
        user: null,
        error: '',
        companyData: null,
        authLoading: {status: false, err: ''},
        companyDataLoadingStatus: true,
        logoutMessage: null,
      };
    case CLEAR_COMPANY_DATA:
      return {
        ...state,
        companyData: null,
      };
    case SHOW_COMPANY_LOAD:
      return {
        ...state,
        companyDataLoadingStatus: true,
      };
    case ADD_COMPANY_DATA:
      return {
        ...state,
        companyData: action.payload,
      };
    case HIDE_COMPANY_LOAD:
      return {
        ...state,
        companyDataLoadingStatus: false,
      };
    case UPDATE_FAMILY_MEMBERS:
      return {
        ...state,
        companyData: {
          ...state.companyData,
          familyMembers: action.payload,
        },
      };
    case UPDATE_COMPANY_WAIVER_SIGNED:
      return {
        ...state,
        companyData: {
          ...state.companyData,
          waiver_signed: true,
        },
      };
    case UPDATE_COMPANY_MEMBER_TNC:
      return {
        ...state,
        companyData: {
          ...state.companyData,
          member: {
            ...state.companyData.member,
            toc: Date.now(),
          },
        },
      };
    case UPDATE_COMPANY_MEMBER_MRF:
      return {
        ...state,
        companyData: {
          ...state.companyData,
          member: {
            ...state.companyData.member,
            mrf: true,
          },
        },
      };
    case UPDATE_FAMILY_MEMBER_QUESTIONS: {
      // Find the family member and update their MRF data
      const familyMembers = state.companyData?.familyMembers || [];
      const updatedFamilyMembers = familyMembers.map(member =>
        member.uuid === action.payload.familyMemberId
          ? {...member, mrfData: action.payload.questionsData}
          : member
      );

      // Also update the MemberRegistrationForm if it exists
      const currentMRF = state.companyData?.MemberRegistrationForm;
      let updatedMRF = currentMRF;

      if (currentMRF && currentMRF.attr) {
        const familyData = currentMRF.attr.family || [];
        const updatedFamilyData = familyData.filter(
          fm => fm.fmId !== action.payload.familyMemberId
        );
        updatedFamilyData.push({
          fmId: action.payload.familyMemberId,
          name: action.payload.questionsData.name || '',
          ...action.payload.questionsData,
        });

        updatedMRF = {
          ...currentMRF,
          attr: {
            ...currentMRF.attr,
            family: updatedFamilyData,
          },
        };
      }

      return {
        ...state,
        companyData: {
          ...state.companyData,
          familyMembers: updatedFamilyMembers,
          MemberRegistrationForm: updatedMRF,
        },
      };
    }
    case SET_FAMILY_MEMBER_REGISTRATION_FORM:
      return {
        ...state,
        companyData: {
          ...state.companyData,
          MemberRegistrationForm: action.payload,
        },
      };
    default:
      return state;
  }
};

export default reducer;
